import { useQuery } from "react-query";
import axios from "infra/http";
import { ContaDetalheCompleteResponse } from "../typings";
import moment from "moment";
import { AxiosError } from "axios";

function useFindContaComplete(id: string | undefined) {
  return useQuery<ContaDetalheCompleteResponse, AxiosError>(
    `/v1/conta/${id}/completa`,
    async () => {
      const { data } = await axios.get<ContaDetalheCompleteResponse>(
        `/v1/conta/${id}/completa`
      );

      if (data.dataCompetencia) {
        data.dataCompetencia = moment(data.dataCompetencia).format("YYYY-MM");
      }

      return { ...data };
    },
    {
      enabled: !!id,
    }
  );
}

export default useFindContaComplete;
